import React from 'react';

class FanIcon extends React.Component {
  state = {
    type: this.props.type
  };
  render() {
    return (
      <React.Fragment>
        {this.state.type === 'rotate' ? (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.0001 0C12.3592 0 12.6907 0.192569 12.8687 0.504509L22.8687 18.0349L21.1314 19.0258L14.1455 6.77927L14.3462 7.80866L12.3831 8.19134L11.534 3.83529L3.29638 18.276C6.51898 20.6339 10.8249 21.4741 14.8307 20.7463L14.3326 18.1913L16.2956 17.8087L16.9816 21.3273C17.0836 21.8507 16.7569 22.3622 16.2391 22.4896C11.1634 23.739 5.42071 22.7001 1.35792 19.2969C0.987153 18.9864 0.891793 18.455 1.13144 18.0349L11.1314 0.504509C11.3094 0.192569 11.6409 0 12.0001 0ZM13.1629 12.1913L12.773 10.1913L14.7361 9.80866L15.126 11.8087L13.1629 12.1913ZM13.9427 16.1913L13.5528 14.1913L15.5159 13.8087L15.9057 15.8087L13.9427 16.1913Z"
              fill="#8A8B8D"
            />
          </svg>
        ) : (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10.4506 1.16446C10.7615 0.959983 11.1603 0.945105 11.4856 1.12584L16.0389 3.65543C18.7019 5.13489 18.7997 8.92946 16.2163 10.5441L16.1604 10.579L21.9005 10.005C22.28 9.96701 22.6481 10.1483 22.8494 10.4723C23.0507 10.7963 23.0502 11.2065 22.848 11.53L20.2257 15.7257C18.7155 18.1421 15.2349 18.2494 13.5787 15.9307L13.3686 15.6366L13.995 21.9005C14.033 22.28 13.8517 22.6481 13.5277 22.8494C13.2037 23.0507 12.7935 23.0502 12.47 22.848L8.27426 20.2257C5.85795 18.7155 5.75062 15.2349 8.06931 13.5787L8.36343 13.3686L2.0995 13.995C1.72919 14.0321 1.36894 13.8604 1.16446 13.5494C0.959983 13.2385 0.945105 12.8397 1.12584 12.5144L3.65543 7.96111C5.13489 5.29808 8.92946 5.20034 10.5441 7.78368L10.579 7.83955L10.005 2.0995C9.96793 1.72919 10.1396 1.36894 10.4506 1.16446ZM10.299 11.1651L8.84805 8.84368C8.04076 7.55201 6.14347 7.60088 5.40374 8.9324L3.80242 11.8148L10.299 11.1651ZM11.1767 13.817L9.23178 15.2062C8.07244 16.0343 8.1261 17.7746 9.33426 18.5297L11.8022 20.0721L11.1767 13.817ZM13.817 12.8233L15.2062 14.7682C16.0343 15.9276 17.7746 15.8739 18.5297 14.6657L20.0721 12.1978L13.817 12.8233ZM12.8349 10.299L15.1563 8.84805C16.448 8.04076 16.3991 6.14347 15.0676 5.40374L12.1852 3.80242L12.8349 10.299Z"
              fill="#8A8B8D"
            />
          </svg>
        )}
      </React.Fragment>
    );
  }
}

export default FanIcon;
